import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import { useSelector } from 'react-redux';
import UserProfile from 'aurora-images/user_profile.svg';
import { keyEmptyCheck } from 'aurora-utils/utils';
import MainMenu from './MainMenu';
import styles from './sidebar-jss';

function SidebarContent(props) {
  const {
    classes,
    drawerPaper,
    toggleDrawerOpen,
    loadTransition,
    leftSidebar,
    dataMenu,
    status,
    anchorEl,
    openMenuStatus,
    closeMenuStatus,
    changeStatus,
    userAttr,
  } = props;

  const [transform, setTransform] = useState(0);
  const refSidebar = useRef(null);

  const userFromProps = useSelector(state => state.userReducer?.user);
  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState({});

  useEffect(() => {
    if (userFromProps?.user) {
      setUser(userFromProps?.user);
    }
  }, [userFromProps]);

  const setStatus = st => {
    switch (st) {
      case 'key1':
        return classes.switcherPrimary;
      case 'key2':
        return classes.switcherSecondary;
      default:
        return classes.switcherDefault;
    }
  };

  const handleScroll = event => {
    setTransform(event.target.scrollTop);
  };

  useEffect(() => {
    refSidebar?.current?.addEventListener('scroll', handleScroll);

    return () => {
      refSidebar?.current?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const lang = localStorage.getItem('lang');
  return (
    <div className={classNames(classes.drawerInner, !drawerPaper ? classes.drawerPaperClose : '')}>
      <div className={classes.drawerHeader}>
        <div className={classes.profile} style={{ opacity: 1 - transform / 100, marginTop: transform * -0.3 }}>
          <Avatar alt={userAttr.name} src={UserProfile} className={classNames(classes.avatar, classes.bigAvatar)} />
          <div>
            <h4>{lang === 'ar' ? localStorage.getItem('UserNameAr') : localStorage.getItem('UserNameEn')}</h4>
            <Button size='small' onClick={openMenuStatus}>
              <i className={classNames(classes.dotStatus, setStatus(status))} />
              {localStorage.getItem('userType') && localStorage.getItem('userType') !== 'undefined' ? (
                keyEmptyCheck(localStorage.getItem('userType'))
              ) : (
                <FormattedMessage {...messages.profileSwitcher} />
              )}
            </Button>
            <Menu
              id='status-menu'
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={closeMenuStatus}
              className={classes.statusMenu}
            >
              <MenuItem onClick={() => changeStatus('key1')}>
                <i className={classNames(classes.dotStatus, classes.switcherPrimary)} />
                <FormattedMessage {...messages.profileSwitcher} />
              </MenuItem>
              <MenuItem onClick={() => changeStatus('key2')}>
                <i className={classNames(classes.dotStatus, classes.switcherSecondary)} />
                <FormattedMessage {...messages.profileSwitcherCompany} />
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
      <div
        id='sidebar'
        ref={refSidebar}
        className={classNames(classes.menuContainer, leftSidebar && classes.rounded, classes.withProfile)}
      >
        <MainMenu loadTransition={loadTransition} dataMenu={dataMenu} toggleDrawerOpen={toggleDrawerOpen} />
      </div>
    </div>
  );
}

SidebarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  userAttr: PropTypes.object.isRequired,
  drawerPaper: PropTypes.bool.isRequired,
  toggleDrawerOpen: PropTypes.func,
  loadTransition: PropTypes.func,
  leftSidebar: PropTypes.bool.isRequired,
  dataMenu: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  anchorEl: PropTypes.object,
  openMenuStatus: PropTypes.func.isRequired,
  closeMenuStatus: PropTypes.func.isRequired,
  changeStatus: PropTypes.func.isRequired,
};

SidebarContent.defaultProps = {
  toggleDrawerOpen: () => {},
  toggleDrawerClose: () => {},
  loadTransition: () => {},
  anchorEl: null,
};

export default withStyles(styles)(injectIntl(SidebarContent));
